<template>
    <div>
    <base-header type="gradient-blue" class="pb-6 pb-8 pt-5 pt-md-8">
        <div class="row mb-2">
            <div class="col-12 col-md-12 col-lg-8">
                <h1 class="text-white pt-3 px-3">รายงานร้านค้าที่ลงทะเบียนคอมมิชชั่น</h1>
                <p
                    class="text-white pb-0 px-3"
                >แสดงร้านค้าที่มีอยู่ทั้งหมด และแสดงสถานะการลงทะเบียนเพื่อรับค่าคอมมิชชั่นของร้านค้า</p>
            </div>
      </div>
    </base-header>
    <div class="text-center" v-if="load.busy">
        <BlockUI>
            <div class="loader"></div>
        </BlockUI>
    </div>
    <div class="container-fluid mt--7 mb-5">
        <div class="row">
            <div class="col">
                <div class="card shadow">
                    <div class="card-header bg-transparent">
                        <ShopSearch :search="search" title="ตารางแสดงรายละเอียดร้านค้าทั้งหมด" @getCommission="getListShopCommission()" />
                        <ShopExport 
                            :load="load"
                            fileName="bookbank" 
                            role="admin" 
                        />
                    </div>
                    <ShopCommissionTable :search="search" :data="data" :fields="fields" @getCommission="getListShopCommission()"  @openFormCreate="openFormCreateShop($event)"/>
                </div>
            </div>
        </div>
    </div>
    <verifyShop 
        :modal="modal" 
        :loading.sync="load.busy" 
        :statusVerify="verify"
        :shippop="shippop"
        @reloadByShippop="getListShopCommission()"
    />
    </div> 
</template>
<script>
const API_URL = process.env.VUE_APP_API;
import validatePop from "../plugins/validatePop.js"
import ShopSearch from '@/components/custom/shop/ShopSearch'
import ShopCommissionTable from '@/components/custom/shop/ShopCommissionTable'
import verifyShop from '@/components/custom/brance/VerifyShop'; 
import ShopExport from '@/components/custom/shop/ShopExport'

export default {
    name:"shopcommission",
    components: {
        ShopSearch,
        ShopCommissionTable,
        verifyShop,
        ShopExport
    },
    data(){
        return {
            load:{
                busy: false,
                isLoading: false
            },
            search: {
                error:false,
                page: 1,
                perPage: 50,
                shop_code: "",
                card_id: "",
                owner_name: "",
                status_register:"",
                api_key:""
            },
            data: {
                commission: [],
                totalItem: 0,
            },
            modal:{
                verifyModal: false,
            },
            verify:{
                status:"null",
                remark:null
            },
            shippop: {
                id: "",
                type: "",
                url: "/shippop/register/commission"
            }
        }
    },
    mounted(){
        this.getListShopCommission()
    },
    methods:{
        openFormCreateShop(id){
            this.shippop.id = id
            this.shippop.type = "admin"
            this.modal.verifyModal = true
        },
        getListShopCommission() {
            this.load.busy = true
            this.$http
                .post(API_URL + "/shippop/shop/commission", {
                   ...this.search
                },
                {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                })
                .then(res => {
                    let checkError = validatePop(res);
                    if (!checkError.status) {
                        this.handleLoader();
                        if (checkError.notices == "token is expired") {
                            this.$router.push("/logout");
                        }
                        this.showErrorModal(checkError.msg);
                        return false;
                    }
                    this.handleLoader();
                    this.data.commission = res.data.data.shop;
                    this.data.totalItem = res.data.data.totalItem;
                    
                });
        },
        handleLoader(){
            this.load.busy = !this.load.busy
        },
    },
    computed:{
        fields(){ 
            let fields = [
                { key: "index", label: "ลำดับ", sortable: true },
                { key: "shop_code", label: "รหัสร้านค้า", sortable: true },
                { key: "card_id", label: "หมายเลขบัตรประชาชน", sortable: true },
                { key: "name", label: "ชื่อร้านค้า", sortable: true },
                { key: "owner_name", label: "ชื่อเจ้าของ", sortable: true },
                { key: "email", label: "อีเมล์", sortable: true },
                { key: "status_resgister", label: "สถานะยืนยันตัวตน", sortable: true },
                { key: "created_at", label: "วันที่ลงทะเบียน", sortable: true },
                { key: "date_time_confirm", label: "วันที่บัญชีอนุมัติออนไลน์", sortable: true },
                { key: "document_approved", label: "วันที่ได้รับเอกสารจริง", sortable: true },
                { key: "sale", label: "เซลล์ที่ดูแล", sortable: true },
                { key: "under_by", label: "สร้างโดย", sortable: true },
                { key: "manage", label: "จัดการ" }
            ]
            return fields
        }
    }
}
</script>